/* TITLIYA — Delivery checker to Shopify cart attributes
   Saves the customer's checked delivery location/type to the cart.
*/
(function () {
  const LOCATION_ID = "titliya-location";
  const RESULT_ID = "titliya-delivery-result";
  const STORAGE_KEY = "titliya_delivery_check";

  function clean(text) {
    return (text || "").replace(/\s+/g, " ").trim();
  }

  function getType(result) {
    if (result.classList.contains("success")) return "60-Minute Delivery";
    if (result.classList.contains("same-day")) return "Same-Day Delivery";
    if (result.classList.contains("standard")) return "Standard Delivery (2–3 Days)";
    return "";
  }

  async function saveToCart(location, type) {
    if (!location || !type) return;

    const payload = {
      attributes: {
        "Delivery Location": location,
        "Delivery Type": type
      }
    };

    try {
      await fetch((window.routes && window.routes.cart_update_url) || "/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(payload)
      });

      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        location: location,
        type: type,
        savedAt: Date.now()
      }));
    } catch (e) {
      /* Do not block checkout if cart attributes fail to save. */
    }
  }

  function init() {
    const input = document.getElementById(LOCATION_ID);
    const result = document.getElementById(RESULT_ID);

    if (!input || !result) return;

    let lastSignature = "";

    const observer = new MutationObserver(function () {
      const type = getType(result);
      const location = clean(input.value);

      if (!type || !location) return;

      const signature = location + "|" + type;

      if (signature === lastSignature) return;
      lastSignature = signature;

      saveToCart(location, type);
    });

    observer.observe(result, {
      attributes: true,
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();